import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight, SlidersHorizontal } from 'lucide-react';
import Header from './components/Header23';
import Footer from './components/Footer23';

const Template23Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const occasions = ['All', 'Wedding', 'Sangeet', 'Festive', 'Mehendi', 'Reception'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        {
            id: 1,
            name: 'Bridal Silk Lehenga',
            occasion: 'Wedding',
            price: 45999,
            image: 'https://images.pexels.com/photos/8881954/pexels-photo-8881954.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: 'Bestseller',
        },
        {
            id: 2,
            name: 'Sangeet Anarkali Set',
            occasion: 'Sangeet',
            price: 18500,
            image: 'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: 'New Arrival',
        },
        {
            id: 3,
            name: 'Festive Zari Saree',
            occasion: 'Festive',
            price: 12999,
            image: 'https://images.pexels.com/photos/2723623/pexels-photo-2723623.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: null,
        },
        {
            id: 4,
            name: 'Wedding Sherwani',
            occasion: 'Wedding',
            price: 28000,
            image: 'https://images.pexels.com/photos/6687182/pexels-photo-6687182.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: 'Popular',
        },
        {
            id: 5,
            name: 'Mehendi Sharara Set',
            occasion: 'Mehendi',
            price: 9999,
            image: 'https://images.pexels.com/photos/5595710/pexels-photo-5595710.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: null,
        },
        {
            id: 6,
            name: 'Reception Gown',
            occasion: 'Reception',
            price: 22500,
            image: 'https://images.pexels.com/photos/9419108/pexels-photo-9419108.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: 'Trending',
        },
        {
            id: 7,
            name: 'Diwali Kurta Set',
            occasion: 'Festive',
            price: 6800,
            image: 'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: null,
        },
        {
            id: 8,
            name: 'Eid Special Gharara',
            occasion: 'Festive',
            price: 14999,
            image: 'https://images.pexels.com/photos/9901808/pexels-photo-9901808.jpeg?auto=compress&cs=tinysrgb&w=800',
            tag: 'Limited Edition',
        },
    ];

    const filteredProducts = activeFilter === 'All'
        ? products
        : products.filter(p => p.occasion === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const totalPages = 3;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');

                .utsav-shop-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .utsav-shop-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 24px;
                    }
                }
                @media (min-width: 1024px) {
                    .utsav-shop-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 28px;
                    }
                }
                .utsav-filter-bar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    align-items: center;
                }
                @media (min-width: 768px) {
                    .utsav-filter-bar {
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
                .utsav-occasion-scroll {
                    display: flex;
                    gap: 10px;
                    overflow-x: auto;
                    padding-bottom: 4px;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .utsav-occasion-scroll::-webkit-scrollbar {
                    display: none;
                }
                .utsav-hero-section {
                    padding: 120px 24px 60px;
                }
                @media (min-width: 768px) {
                    .utsav-hero-section {
                        padding: 140px 24px 80px;
                    }
                }
                .utsav-product-card:hover .utsav-card-overlay {
                    opacity: 1;
                }
                .utsav-product-card:hover img {
                    transform: scale(1.05);
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FFFDF8' }}>
                <Header cartCount={0} />

                {/* Hero Banner */}
                <div
                    className="utsav-hero-section"
                    style={{
                        background: 'linear-gradient(135deg, #1B3A2D 0%, #2D5A45 50%, #1B3A2D 100%)',
                        textAlign: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                    }}
                >
                    {/* Decorative pattern overlay */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `radial-gradient(circle at 20% 50%, rgba(197, 151, 75, 0.08) 0%, transparent 50%),
                                         radial-gradient(circle at 80% 50%, rgba(197, 151, 75, 0.08) 0%, transparent 50%)`,
                        pointerEvents: 'none',
                    }} />
                    <div style={{ maxWidth: '800px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
                        <div style={{
                            width: '60px',
                            height: '2px',
                            backgroundColor: '#C5974B',
                            margin: '0 auto 20px',
                        }} />
                        <p
                            style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#C5974B',
                                letterSpacing: '4px',
                                textTransform: 'uppercase',
                                margin: '0 0 16px 0',
                            }}
                        >
                            Celebrate in Style
                        </p>
                        <h1
                            style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: 'clamp(32px, 5vw, 56px)',
                                fontWeight: 700,
                                color: '#FFFFFF',
                                letterSpacing: '2px',
                                margin: '0 0 16px 0',
                                lineHeight: 1.2,
                            }}
                        >
                            Festive Collection
                        </h1>
                        <p
                            style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '16px',
                                fontWeight: 300,
                                color: 'rgba(255,255,255,0.85)',
                                margin: 0,
                                lineHeight: 1.7,
                                maxWidth: '500px',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        >
                            Handcrafted ensembles for every celebration — from intimate mehendi ceremonies to grand wedding receptions
                        </p>
                        <div style={{
                            width: '60px',
                            height: '2px',
                            backgroundColor: '#C5974B',
                            margin: '24px auto 0',
                        }} />
                    </div>
                </div>

                {/* Main Content */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '40px 24px 80px' }}>

                    {/* Filter / Sort Bar */}
                    <div className="utsav-filter-bar" style={{ marginBottom: '40px' }}>
                        {/* Occasion Tabs */}
                        <div className="utsav-occasion-scroll">
                            {occasions.map(occasion => (
                                <button
                                    key={occasion}
                                    onClick={() => {
                                        setActiveFilter(occasion);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        padding: '10px 24px',
                                        backgroundColor: activeFilter === occasion ? '#C5974B' : 'transparent',
                                        color: activeFilter === occasion ? '#FFFFFF' : '#1B3A2D',
                                        border: activeFilter === occasion ? '1px solid #C5974B' : '1px solid #E8E0D4',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeFilter !== occasion) {
                                            e.currentTarget.style.borderColor = '#C5974B';
                                            e.currentTarget.style.color = '#C5974B';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeFilter !== occasion) {
                                            e.currentTarget.style.borderColor = '#E8E0D4';
                                            e.currentTarget.style.color = '#1B3A2D';
                                        }
                                    }}
                                >
                                    {occasion}
                                </button>
                            ))}
                        </div>

                        {/* Sort Dropdown */}
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '13px',
                                fontWeight: 500,
                                color: '#1B3A2D',
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #E8E0D4',
                                padding: '10px 40px 10px 16px',
                                borderRadius: '8px',
                                outline: 'none',
                                cursor: 'pointer',
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23C5974B' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 12px center',
                                minWidth: '180px',
                            }}
                            onFocus={(e) => (e.currentTarget.style.borderColor = '#C5974B')}
                            onBlur={(e) => (e.currentTarget.style.borderColor = '#E8E0D4')}
                        >
                            {sortOptions.map(option => (
                                <option key={option.value} value={option.value} style={{ backgroundColor: '#FFFFFF', color: '#1B3A2D' }}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Results Count */}
                    <p style={{
                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                        fontSize: '14px',
                        color: '#5A5A5A',
                        margin: '0 0 24px 0',
                    }}>
                        Showing {sortedProducts.length} {activeFilter === 'All' ? 'products' : `${activeFilter} pieces`}
                    </p>

                    {/* Product Grid */}
                    <div className="utsav-shop-grid">
                        {sortedProducts.map(product => (
                            <div
                                key={product.id}
                                className="utsav-product-card"
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: hoveredCard === product.id
                                        ? '0 12px 40px rgba(27, 58, 45, 0.12)'
                                        : '0 2px 12px rgba(27, 58, 45, 0.06)',
                                    transition: 'all 0.4s ease',
                                    transform: hoveredCard === product.id ? 'translateY(-4px)' : 'translateY(0)',
                                }}
                                onClick={() => navigate(`/template23/product/${product.id}`)}
                                onMouseEnter={() => setHoveredCard(product.id)}
                                onMouseLeave={() => setHoveredCard(null)}
                            >
                                {/* Image */}
                                <div style={{
                                    position: 'relative',
                                    paddingBottom: '130%',
                                    overflow: 'hidden',
                                    backgroundColor: '#F8F3EC',
                                }}>
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.6s ease',
                                        }}
                                    />
                                    {/* Tag */}
                                    {product.tag && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '12px',
                                            left: '12px',
                                            backgroundColor: '#7A1B3B',
                                            color: '#FFFFFF',
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '10px',
                                            fontWeight: 700,
                                            letterSpacing: '1px',
                                            textTransform: 'uppercase',
                                            padding: '5px 12px',
                                            borderRadius: '4px',
                                        }}>
                                            {product.tag}
                                        </div>
                                    )}
                                    {/* Wishlist */}
                                    <button
                                        onClick={(e) => toggleWishlist(e, product.id)}
                                        style={{
                                            position: 'absolute',
                                            top: '12px',
                                            right: '12px',
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            backgroundColor: 'rgba(255,255,255,0.9)',
                                            border: 'none',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s ease',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                        <Heart
                                            size={16}
                                            fill={wishlist[product.id] ? '#7A1B3B' : 'none'}
                                            color={wishlist[product.id] ? '#7A1B3B' : '#1B3A2D'}
                                        />
                                    </button>
                                    {/* Quick View Overlay */}
                                    <div
                                        className="utsav-card-overlay"
                                        style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            padding: '16px',
                                            background: 'linear-gradient(transparent, rgba(27, 58, 45, 0.85))',
                                            opacity: 0,
                                            transition: 'opacity 0.3s ease',
                                        }}
                                    >
                                        <button style={{
                                            width: '100%',
                                            padding: '10px',
                                            backgroundColor: '#C5974B',
                                            color: '#FFFFFF',
                                            border: 'none',
                                            borderRadius: '6px',
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '12px',
                                            fontWeight: 700,
                                            letterSpacing: '1px',
                                            textTransform: 'uppercase',
                                            cursor: 'pointer',
                                        }}>
                                            Quick View
                                        </button>
                                    </div>
                                </div>

                                {/* Info */}
                                <div style={{ padding: '16px' }}>
                                    <p style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '10px',
                                        fontWeight: 600,
                                        color: '#C5974B',
                                        letterSpacing: '1.5px',
                                        textTransform: 'uppercase',
                                        margin: '0 0 6px 0',
                                    }}>
                                        {product.occasion}
                                    </p>
                                    <h3 style={{
                                        fontFamily: "'Libre Baskerville', Georgia, serif",
                                        fontSize: '15px',
                                        fontWeight: 400,
                                        color: '#1B3A2D',
                                        margin: '0 0 8px 0',
                                        lineHeight: 1.3,
                                    }}>
                                        {product.name}
                                    </h3>
                                    <p style={{
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '16px',
                                        fontWeight: 700,
                                        color: '#C5974B',
                                        margin: 0,
                                    }}>
                                        {'\u20B9'}{product.price.toLocaleString('en-IN')}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '60px',
                    }}>
                        <button
                            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                            disabled={currentPage === 1}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #E8E0D4',
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: currentPage === 1 ? 0.3 : 1,
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <ChevronLeft size={16} color="#1B3A2D" />
                        </button>

                        {[1, 2, 3].map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: currentPage === page ? '#1B3A2D' : 'transparent',
                                    color: currentPage === page ? '#FFFFFF' : '#1B3A2D',
                                    border: currentPage === page ? '1px solid #1B3A2D' : '1px solid #E8E0D4',
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                {page}
                            </button>
                        ))}

                        <button
                            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                            disabled={currentPage === totalPages}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #E8E0D4',
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: currentPage === totalPages ? 0.3 : 1,
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <ChevronRight size={16} color="#1B3A2D" />
                        </button>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template23Shop;
